const CreateMemories = {
  Memorial: {
    url: "/memorial",
    method: "POST",
  },
  GetMemorial: (id) => ({
    url: `/memorial/${id}`,
    method: "GET",
  }),
  UpdateMemorial: (id) => ({
    url: `/memorial/${id}`,
    method: "PUT",
  }),
  MemorialTimeline: {
    url: "/memorial/timeline",
    method: "POST",
  },
  MemorialComment: {
    url: "/memorial/comment",
    method: "POST",
  },
  SaveMemorialFamilyTree: {
    url: "/memorial/family-tree",
    method: "POST",
  },
  memorialAlbum: {
    url: "/memorial/album",
    method: "POST",
  },
  getmemorials: (id) => ({
    url: `/memorial-album/${id}`,
    method: "GET",
  }),
  getmemorialAlbum: (albumId) => ({
    url: `/memorial/album/${albumId}`,
    method: "GET",
  }),
  updatememorialAlbum: (id) => ({
    url: `/memorial/album/${id}`,
    method: "PUT",
  }),
  deletememorialAlbum: (id) => ({
    url: `/memorial/album/${id}`,
    method: "Delete",
  }),

  SaveMemorialUserPermission: {
    url: "/memorial/user-permission",
    method: "POST",
  },
  GetMemorialUserPermission: (permission) => ({
    url: `/memorial/user-permission/${permission}`,
    method: "GET",
  }),
  DeleteMemorialUserPermission: (permissionId) => ({
    url: `/memorial/user-permission/${permissionId}`,
    method: "DELETE",
  }),
  MemorialPermissionStatus: {
    url: "/memorial/permission-status",
    method: "PATCH",
  },
  memorialAlbumPhoto: {
    url: "/memorial/album-photo",
    method: "POST",
  },
  getAlbumPhoto: (id) => ({
    url: `/memorial/album-photo/${id}`,
    method: "GET",
  }),
  putAlbumPhoto: (id) => ({
    url: `/memorial/album-photo/${id}`,
    method: "PUT",
  }),
  deleteAlbumPhoto: (id) => ({
    url: `/memorial/album-photo/${id}`,
    method: "DELETE",
  }),

  getMemorialTimeline: (memorialId) => ({
    url: `/memorial-timeline/${memorialId}`,
    method: "GET",
  }),
  getTimeline: (timelineId) => ({
    url: `/memorial/timeline/${timelineId}`,
    method: "GET",
  }),
  UpdateTimeline: (timelineId) => ({
    url: `/memorial/timeline/${timelineId}`,
    method: "PUT",
  }),
  DeleteTimeline: (timelineId) => ({
    url: `/memorial/timeline/${timelineId}`,
    method: "DELETE",
  }),
  getMemorialCommentList: (memorialId) => ({
    url: `/memorial-comment/${memorialId}`,
    method: "GET",
  }),
  getDownloadableContent: (memorialId, type) => ({
    url: `/memorial/${memorialId}/downloadable-content/${type}`,
    method: "GET",
  }),
  getAllDownloadableContent: (memorialId) => ({
    url: `/memorial/${memorialId}/all-downloadable-content`,
    method: "GET",
  }),
  getSingleComment: (memorialId) => ({
    url: `/memorial/comment-user/${memorialId}`,
    method: "GET",
  }),
  editComment: (commentId) => ({
    url: `/memorial/comment/${commentId}`,
    method: "PUT",
  }),
  saveSpouse: {
    url: `/memorial/family-tree/spouse`,
    method: "POST",
  },
  getFamilyTree: (familyTreeId) => ({
    url: `/memorial/family-tree/${familyTreeId}`,
    method: "GET",
  }),
  updateFamilyTree: (familyTreeId) => ({
    url: `/memorial/family-tree/${familyTreeId}`,
    method: "PUT",
  }),
  deleteFamilyTree: (memorialId) => ({
    url: `/memorial/family-tree/${memorialId}`,
    method: "DELETE",
  }),
  deletePaternalTreeIndividual: (memorialId, individualId) => ({
    url: `/memorial/paternal-tree/${memorialId}/individual/${individualId}`,
    method: "DELETE",
  }),
  deleteFamilyTreeIndividual: (memorialId, individualId) => ({
    url: `/memorial/family-tree/${memorialId}/individual/${individualId}`,
    method: "DELETE",
  }),
  deleteFamilyTreeSpouse: (memorialId, spouseId) => ({
    url: `/memorial/family-tree/${memorialId}/spouse/${spouseId}`,
    method: "DELETE",
  }),
  updateFamilyTreeSpouse: (spouseId) => ({
    url: `/memorial/family-tree/spouse/${spouseId}`,
    method: "PUT",
  }),
  getSpouseById: (spouseId) => ({
    url: `/memorial/family-tree/spouse/${spouseId}`,
    method: "GET",
  }),
};

export default CreateMemories;
